import { useTranslation } from "@redotech/redo-i18n";
import { EvaluationTime } from "@redotech/redo-return-core-common/return-flow/condition-enums";
import type { CustomerTagState } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { RedoTagInputField } from "@redotech/redo-web/arbiter-components/input/redo-tag-input-field";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useMemo, useState } from "react";
import { EvaluationTimeRadio } from "./evaluation-time-radio";

export const CustomerTagDetails = memo(function CustomerTagDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<CustomerTagState>) {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState("");

  const tags = useMemo(
    () => state.tags.map((tag) => ({ text: tag, color: "gray" as const })),
    [state.tags],
  );

  return (
    <Flex dir="column" gap="sm">
      <RedoTagInputField
        delimiters={["newline"]}
        inputValue={inputValue}
        label={t("Customer tags")}
        placeholder={t("Type and press Enter to add tags")}
        setInputValue={setInputValue}
        setTags={(tags) => setState({ ...state, tags })}
        size="sm"
        state={disabled ? "disabled" : "default"}
        tags={tags}
      />
      <EvaluationTimeRadio
        defaultValue={EvaluationTime.TIME_OF_ORDER}
        disabled={disabled}
        label={t("Evaluate customer tags at")}
        setValue={(evaluationTime) => setState({ ...state, evaluationTime })}
        value={state.evaluationTime}
      />
    </Flex>
  );
});
